<template>
  <div class="row">
    <router-view
      v-bind="{
        dataSelect: this.dataSelect,
        textErreur: this.textErreur,
        textFormulaire: this.textFormulaire
      }"
    />
    <div
      class="col s12"
      v-for="(dataText, index) in textFormulaire"
      :key="index"
    >
      <div class="col s12 wrapper-consent">
        <h2>{{ dataText.accueilCTitre }}</h2>
        <div v-html="dataText.accueilCIntroTexte"></div>
      </div>
      <div class="row">
        <!-- {{ card 1 }} -->
        <div class="col s12 l6 wrapper-card_unit">
          <div class="card horizontal hoverable z-depth-2 pl-10">
            <div class="card-image">
              <i
                aria-hidden="true"
                class="material-icons large orange-text text-darken-4"
                >person</i
              >
            </div>
            <div class="card-stacked">
              <div class="card-content text-center">
                <!-- <p>{{ isniDemande }}</p> -->
                <p>{{ dataText.accueilCCtaPersonneTitre }}</p>
              </div>
              <div class="card-action">
                <router-link
                  title="Demande d'ISNI pour une personne"
                  :to="{
                    name: 'demande-personnel',
                    params: {
                      isniForms,
                      validateEmail,
                    },
                  }"
                  class="light-blue-text text-darken-4"
                  >{{ dataText.accueilCCtaPersonneLabel }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <!-- {{ card 1 }} -->

        <!-- {{ card 2 }} -->
        <div class="col s12 l6 wrapper-card_unit">
          <div class="card horizontal hoverable z-depth-2 pl-10">
            <div class="card-image">
              <i
                aria-hidden="true"
                class="material-icons large orange-text text-darken-4"
                >people</i
              >
            </div>
            <div class="card-stacked">
              <div class="card-content text-center">
                <!-- <p>{{ isniDemande }}</p> -->
                <p>{{ dataText.accueilCCtaOrganismeTitre }}</p>
              </div>
              <div class="card-action">
                <router-link
                  title="Demande d'ISNI pour un organisme"
                  :to="{
                    name: 'demande-organisme',
                    params: {
                      isniFormsOrga,
                      validateEmail,
                    },
                  }"
                  class="light-blue-text text-darken-4"
                  >{{ dataText.accueilCCtaPersonneLabel }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <!-- {{ card 2 }} -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import M from "materialize-css";
/** Recupere le data json du formulaire Personnel */
import isniForms from "@/data/isniforms.json";
/** Recupere le data json du formulaire Organisme */
import isniFormsOrga from "@/data/isniformsOrga.json";
import { langService } from "@/services/lang.service";

export default {
  name: "Home",
  props: {
    dataSelect: {
      type: Object,
      required: true
    },
    textErreur: {
      type: Object,
      required: true
    },
    textFormulaire: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      isniForms,
      isniFormsOrga,
      validateEmail: true
    };
  },
  created() {
    if (this.$route.query["not-validate-email"] === "true") {
      this.validateEmail = false;
    }
    if (this.$route.query["lang"] === "en") {
      // update lang to all pages
      langService.setLang('en');

      // spread the new lang triggers
      this.$emit('emailReceiptPageChangesLangTrigger');
    }
  },
  mounted() {
    M.AutoInit();
  },
  updated() {
    M.AutoInit();
  }
};
</script>
<style lang="scss">
.main-wrapper {
  .wrapper-consent {
    ul > li {
      list-style-type: initial;
      margin-left: 20px;
    }
    p {
      font-weight: 400;
    }
  }
}
</style>
